import { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useImmer } from 'use-immer'
import { Button, FormControl, FormLabel, Input, Select, VStack } from '@chakra-ui/react'

export const VerticalSupportOptionFormType = {
  Add: 'add',
  Edit: 'edit'
}

export const VerticalSupportOptionForm = ({ type, onSubmit, isSubmitting, initialForm = null }) => {
  const [form, setForm] = useImmer({
    description: '',
    baseCost: 0,
    footCost: 0,
    category: ''
  })

  const buttonText = useMemo(() => {
    switch (type) {
      case VerticalSupportOptionFormType.Add:
        return 'Add Option'
      case VerticalSupportOptionFormType.Edit:
        return 'Save Option'
    }
  }, [type])

  useEffect(() => {
    setForm(draft => {
      Object.keys(initialForm || {}).forEach(k => { draft[k] = initialForm[k] ?? '' })
    })
  }, [initialForm])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <form onSubmit={handleSubmit}>
      <VStack gap={2} maxW="500px">
        <FormControl isRequired>
          <FormLabel>Description</FormLabel>
          <Input name="description" value={form.description} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Base Cost</FormLabel>
          <Input type="number" name="baseCost" value={form.baseCost} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Foot Cost</FormLabel>
          <Input type="number" name="footCost" value={form.footCost} onChange={handleChange} />
        </FormControl>
        <FormControl>
          <FormLabel>Category</FormLabel>
          <Select name="category" value={form.category || ''} onChange={handleChange}>
            <option value="">None</option>
            <option value="pole">Pole (per-thickness tube)</option>
            <option value="pole_legacy">Pole Legacy</option>
            <option value="structural">Structural</option>
            <option value="wall_mount">Wall Mount</option>
            <option value="retrofit">Retro-Fit</option>
          </Select>
        </FormControl>
      </VStack>
      <Button type="submit" mt={8} colorScheme="blue" isLoading={isSubmitting}>{buttonText}</Button>
    </form>
  )
}

VerticalSupportOptionForm.propTypes = {
  type: PropTypes.oneOf(Object.values(VerticalSupportOptionFormType)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  initialForm: PropTypes.object
}
